import {
            REGISTER_SUCCESS,
            REGISTER_FAIL,
            USER_LOADED,
            AUTH_ERROR,
            LOGIN_SUCCESS,
            LOGIN_FAIL,
            LOGOUT,
            CLEAR_PROFILE, DELETE_ACCOUNT
} from '../action/type';

const initialState = {
            token: localStorage.getItem('token'),
            isAuthenticated: false,
            loading: true,
            user: null
}



export default function (state = initialState, action) {
            const { type, payload } = action
            switch (type) {
                        case USER_LOADED:
                                    return {
                                                ...state,
                                                isAuthenticated: true,
                                                loading: false,
                                                success: true,
                                                user: payload
                                    }
                        case REGISTER_SUCCESS:
                        case LOGIN_SUCCESS:
                                    localStorage.setItem('token', payload.token);
                                    return {
                                                ...state,
                                                ...payload,
                                                isAuthenticated: true,
                                                loading: false

                                    }

                        case REGISTER_FAIL:
                        case AUTH_ERROR:
                        case LOGIN_FAIL:
                        case LOGOUT:
                        case DELETE_ACCOUNT:
                                    localStorage.removeItem('token')
                                    return {
                                                ...state,
                                                token: false,
                                                isAuthenticated: false,
                                                loading: false

                                    }

                        default:
                                    return state;

            }
}